import { bus } from "@/main";
import { getProductEntry } from "../../../data/models/product.model";
// import { getArticleEntry } from "../../../data/models/article.model";
// import pdf from "pdfvuer";


export default {
	name: "ExhibitionPage",
	components: {},
	data() {
		return {
			isReady: false,
			content: [],
			pageLeft: 0,
			pageRight: 1,
			openSection: 0,
			activeSection: "general",
			language: this.$route.params.lang,
			url: window.location.href
		}
	},
	props: {},
	created() {
		this.getContent();
		bus.$emit("hideTitle", true);
	},
	mounted() {
	},
	watch: {
		$route: function() {
			this.getContent();
			this.language = this.$route.params.lang;
			this.url = window.location.href;
		},
	},
	computed: {
		pageUrl: function () {
			return location.href;
		}
	},
	methods: {
		async getContent(){
			this.content = await new getProductEntry(this.$route.params.publication, "slug", 1);
			this.isReady = true
			setTimeout(() => {
				let page = document.getElementById("publication-page");
				if(page) {
					page.addEventListener("scroll", () => {
						this.evalScroll();
					})
				}
			}, 200);
		},
		nextPage() {
			this.pageLeft = this.pageLeft + 2; 
			this.pageRight = this.pageRight + 2; 
		},
		prevPage() {
			this.pageLeft = this.pageLeft - 2;
			this.pageRight = this.pageRight - 2; 
		},
		scrollTo(id) {
			const el = document.getElementById(id);
			let page = document.getElementById("publication-page")
			page.scroll({
				top: 0,
				left: el.offsetLeft,
				behavior: "smooth"
			});
		},
		evalScroll(id) {
			let page = document.getElementById("publication-page");
			const elIds = ["general", "viewer", "credits"];

			for (let i = 0; i < elIds.length; i++) {
				const id = elIds[i];
				const el = document.getElementById(id);
				
				if (page.scrollLeft + el.offsetLeft / 2 > el.offsetLeft && page.scrollLeft < (el.offsetLeft + el.offsetWidth / 2) ) {
					this.activeSection = id;
				}				
			}

		},
		getPageLeft() {
			if(this.pageLeft > 0 ) {
				return this.pageLeft;
			} else {
				return 2;
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/publication/publication.page.js